import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'relative',
      display: 'flex',
      flexFlow: 'column nowrap',
      background: theme.palette.common.white,
      border: theme.shape.borderGray60,
      borderRadius: theme.shape.borderRadius,

      '&:not($disabled)': {
        '&:hover': {
          border: theme.shape.borderGray50,
        },
        '&:focus-within': {
          border: theme.shape.borderPrimary,
        },
      },
    },
    disabled: {},
    editorDisabled: {
      backgroundColor: COLORS.gray.gray80,
    },
  }),
  { name: 'PromptInstructions' }
);
